export {default as all} from './all'
export {default as new} from './new'
export {default as guestManagement} from './guestManagement/guestManagement.tab'
export {default as inHouseReport} from './guestManagement/inHouseReport.tab'
export {default as rateModificationsList} from './rateManagement/rateModifications/list'
export {default as rateModifications} from './rateManagement/rateModifications'
export {default as rateManagement} from './rateManagement/rates.tab'
export {default as rateTypes} from './rateManagement/types.tab'
export {default as blackouts} from './rateManagement/blackouts.tab'
export {default as bookingConditions} from './bookingConditions'
export {default as amenitiesAndPhotos} from './information/amenitiesAndPhotos'
export {default as details} from './information/details'
export {default as employees} from './administration/employees'
export {default as channels} from './administration/channels'
export {default as reservations} from './administration/reservations'
export {default as locationEmails} from './administration/locationEmails'
export {default as profile} from './profile'
export {default as parkingLease} from './rateManagement/leaseTypes/parkingLease'
